var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3495_17028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00390625,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3495_17028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6039 21L13.3039 14.7C12.8039 15.1 12.2289 15.4167 11.5789 15.65C10.9289 15.8833 10.2372 16 9.50391 16C7.68724 16 6.14974 15.3708 4.89141 14.1125C3.63307 12.8542 3.00391 11.3167 3.00391 9.5C3.00391 7.68333 3.63307 6.14583 4.89141 4.8875C6.14974 3.62917 7.68724 3 9.50391 3C11.3206 3 12.8581 3.62917 14.1164 4.8875C15.3747 6.14583 16.0039 7.68333 16.0039 9.5C16.0039 10.2333 15.8872 10.925 15.6539 11.575C15.4206 12.225 15.1039 12.8 14.7039 13.3L21.0039 19.6L19.6039 21ZM9.50391 14C10.7539 14 11.8164 13.5625 12.6914 12.6875C13.5664 11.8125 14.0039 10.75 14.0039 9.5C14.0039 8.25 13.5664 7.1875 12.6914 6.3125C11.8164 5.4375 10.7539 5 9.50391 5C8.25391 5 7.19141 5.4375 6.31641 6.3125C5.44141 7.1875 5.00391 8.25 5.00391 9.5C5.00391 10.75 5.44141 11.8125 6.31641 12.6875C7.19141 13.5625 8.25391 14 9.50391 14Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.94173d698d1e43abf19fb47866c594e7.svg";
export { ForwardRef as ReactComponent };